export default "__VITE_ASSET__C2Tsu0y6__"